export enum ContentType {
    text,
    image,
    video
}